// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
/*import Search from './Search';*/
import Profile from './Profile';
//import Logout from './Logout';
/*import Customization from './Customization';*/
//import MobileSection from './MobileSection';

import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

import { MenuOrientation } from 'config';

// notifications import
import { NotificationsBadge } from 'contexts/notifications';
import TaskButton from './TaskButton';
import UserName from './userName';

// whatsapp
import WhatsappHeaderIcon from 'apps/whatsapp-chat/components/WhatsappHeaderIcon';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { menuOrientation } = useConfig();
  const { user } = useAuth();

  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  // Check if user has role 1 or 100
  const canViewWhatsapp = user && (user.role === 1 || user.role === 100);

  return (
    <>
      
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      {/*!downLG && <Search />*/}
      {!downLG && <UserName />}
      <Box sx={{ width: '100%', ml: 1 }}/>
      {/* <NotificationsBadge /> */}
      {/* <TaskButton /> */}
      {canViewWhatsapp && <WhatsappHeaderIcon />}
      <Profile />
      {/*!downLG && <Logout />*/}
      {/* <Customization /> */}
      {/*downLG && <MobileSection />*/}
    </>
  );
};

export default HeaderContent;
